import config from "@/config";
import { FormFields, FormValues } from "@/types";
import questionaryInfoFields from "@/questionaryFieldsConfig";

export const getQuestionaryInfoFields = () => {
  return questionaryInfoFields.filter(i => (config.questionaryHiddenField as string[]).indexOf(i.name) === -1);
};

export const getValues = (fields: FormFields, info?: Record<string, string>) =>
  fields.reduce<FormValues>((out, item) => {
    out[item.name] = info ? info[item.name] ?? "" : "";
    return out;
  }, {});
